<template>

  <div class="ibox">
    <div class="ibox-title pt-3">
      <h5><strong>Credenciais</strong></h5>
    </div>

    <div class="ibox-content">
      <div class="row">
        <div class="col-md-12">
          <button
              @click="showModal=true"
              class="btn btn-primary btn-lg"
          >
            Adicionar credenciais
          </button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <table class="table table-borderless table-border">
            <thead>
              <tr>
                <th>Apelido</th>
                <th>App</th>
                <th>Serviço</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="credential in credentials" :key="credential.id">
                <td>{{ credential.nickname }}</td>
                <td>{{ credential.appName }}</td>
                <td>{{ credential.serviceName }}</td>
              </tr>
            </tbody>
          </table>

          <div class="row">
            <div class="col-md-12 my-1">
              <Pagination
                v-model="meta.currentPage"
                :total-count="meta.totalCount"
                :total-pages="meta.totalPages"
                @pagination="pagination"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <Modal v-model="showModal">
      <span slot="header">
        Vincular empresa a credencial
      </span>

      <Select2 v-model="credentialIds" :options="optionsCredentials"/>

      <template slot="footer">
        <button @click="showModal=false" class="btn btn-outline btn-lg">Cancelar</button>
        <button @click="updateCredentials" class="btn btn-primary btn-lg">Salvar</button>
      </template>

    </Modal>
  </div>

</template>

<script>
  import Pagination from '@/components/shares/specialTag/Pagination'
  import Select2 from '@/components/shares/Select2'
  import Modal from '@/components/shares/specialTag/Modal'
  import ModelMapper from '@/mixins/ModelMapper'
  import EntityProxy from '@/models/EntityProxy'

  export default {
    components: { Modal, Pagination, Select2 },
    computed: {
      credentials() {
        return this.getModels || []
      },
      optionsCredentials() {
        return this.allCredentials.map(c => ({ label: `${c.nickname} - ${c.appName}`, value: c.id }))
      }
    },
    created() {
      this.query.companyId = this.company.id
      this.find()
    },
    data() {
      return {
        nameModel: 'Credential',
        allCredentials: [],
        companyCredentialIds: [],
        showModal: false,
        credentialIds: null
      }
    },
    methods: {
      loadAllCredentials() {
        const params = { meta: false, per_page: 1000 }
        this.axios.get('credentials', { params })
          .then(response => response.data)
          .then(credentials => {
            const filtered = credentials.filter(c => c.app_name === 'cm-embarcador')
            this.allCredentials = EntityProxy.build(filtered)
          })
      },
      find() {
        this.asyncTemplateSelect({
          after: () => {
            this.credentialIds = this.credentials.map(u => u.id)
            this.loadAllCredentials()
          }
        })
      },
      updateCredentials() {
        this.openLoad()
        this.axios.put(`companies/${this.company.id}`, { credential_ids: this.credentialIds })
          .then(() => this.find())
          .then(() => this.showModal = false)
          .catch(e => this.$notify.addError(e))
          .finally(() => this.closeLoad())
      },
    },
    mixins: [ModelMapper],
    name: 'CardCredentails',
    props: {
      company: { required: true, type: Object }
    }
  }
</script>

<style scoped>

</style>
